import React, { useEffect, useState } from 'react';
import { Col, Form, Label, Row } from 'reactstrap';
import Header from '../Headers/Header';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import Footer from '../Footer/Footer';
import { Auth } from 'aws-amplify';
import FlashMessages from '../Common/Messages/FlashMessages';
import { FLASH_MESSAGE } from '../../actionTypes/ErrorMessage/FlashMessage';
import SuccessResetPassword from './SuccessResetPassword';
import { useDispatch } from 'react-redux';
import { setNavigateToMsg } from '../../actions/Notifications/ScreenReaderInit';
import { setPageTitle } from '../../actions/Page/PageAction';
import { FormButtons } from '../Common';

const schema = yup.object().shape({
  email: yup.string().email('Email validation failed').required('Email can not be empty'),
});

export const AccountLocked = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [submittedEmail, setSubmittedEmail] = useState('');
  const [flashMsg, setFlashMsg] = useState({ ...FLASH_MESSAGE });
  const [isBusy, setIsBusy] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: { email: '' },
    mode: 'onBlur',
    resolver: yupResolver(schema),
  });

  const onSubmit = handleSubmit(async ({ email }) => {
    setIsBusy(true);
    try {
      await Auth.forgotPassword(email).then((_) => {});
      setSubmittedEmail(email);
    } catch (err) {
      console.error(err);
      setFlashMsg({ ...FLASH_MESSAGE, msgType: 'error', msg: 'Cannot complete current request. Please try again' });
    }
    setIsBusy(false);
  });

  const hideFlashMessage = () => {
    setFlashMsg({ ...FLASH_MESSAGE });
  };

  useEffect(() => {
    dispatch(setNavigateToMsg('Account Locked'));
    dispatch(setPageTitle('Account Locked'));
    return () => {
      dispatch(setPageTitle());
    };
  }, []);

  return (
    <div>
      <Header />
      <FlashMessages
        scope="AccountLock"
        close={hideFlashMessage}
        type={flashMsg.msgType}
        msg={flashMsg.msg}
        open={!!flashMsg.msg}
        classNames="lsn-default"
      />
      <main role="main" className="main-page">
        <div className="mobile_margin account-locked fontSm-15">
          <div>
            <h1 id="formTitle" className="heading-h1-50">
              Account Locked
            </h1>
          </div>

          <Form onSubmit={onSubmit} role={'form'} aria-labelledby={'formTitle innerFormTitle'} className="pSm-30">
            {!submittedEmail ? (
              <React.Fragment>
                <div className={'inner-content'}>
                  <i className="fal fa-lock"></i>
                  <h2 className="mYSm-15">
                    You've exceeded the maximum number of failed sign-in attempts. Enter you account's email to receive
                    instructions on how to reset you password.
                  </h2>
                </div>

                <Row className="v-middle-align">
                  <Label for="email" className="ScalaSansOT" sm={2}>
                    Email
                  </Label>
                  <Col className="input-left" sm={10}>
                    <input
                      aria-describedby={errors.email?.message ? 'email_error' : ''}
                      aria-label={'email'}
                      {...register('email')}
                      className={`input ${errors.email?.message ? 'border-error' : ''}`}
                      name="email"
                      id="email"
                      data-testid="email"
                    />
                  </Col>
                  {errors.email?.message && (
                    <span role="alert" id="email_error" className="input-error">
                      {errors.email?.message}
                    </span>
                  )}
                </Row>

                <FormButtons
                  isBusy={isBusy}
                  submitLabel="Reset"
                  wrapperClassNames={['mTop-40']}
                  extraButtonProps={{
                    stretch: true,
                    type: isBusy ? 'button' : 'submit',
                    classNames: ['mBottom-20'],
                    id: 'button-send-reset-password-link-email',
                  }}
                  cancelLabel="Cancel and Return to Sign In"
                  onCancel={'/login'}
                />
              </React.Fragment>
            ) : (
              <SuccessResetPassword backToSignIn={() => navigate('/login')} email={submittedEmail} />
            )}
          </Form>
        </div>
      </main>
      <Footer />
    </div>
  );
};
